<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 500px; max-width: 80vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span v-if="action==='insert'">ثبت محصول جدید</span>
        <span v-if="action!=='insert'">ویرایش اطلاعات محصول</span>
        <q-badge color="red" text-color="white" :label="newProduct.Goods_Code"/>
        <template v-slot:action>
          <q-btn flat icon="close" round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding" v-if="action==='insert'">
      <q-toggle v-model="repeatInsert" label="ثبت سری محصولات"/>
    </q-card-section>
    <q-form @submit="onSubmit">
      <q-card-section class="q-gutter-sm">
        <q-select v-model="newProduct.Goods_Group"
                  filled
                  :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties'].includes(v))"
                  label="گروه کالا"
                  use-input
                  @filter="filterFnGoodsGroup"
                  :options="goodsGroupOptions"
                  option-label="Group_Name"
                  option-value="Group_ID"
                  hide-bottom-space
                  :rules="[requireRole]"
        />
        <q-select v-model="newProduct.Goods_Unit"
                  filled
                  hide-bottom-space
                  :rules="[requireRole]"
                  label="واحد کالا"
                  :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties'].includes(v))"
                  :options="goodUnits"
                  option-label="Unit_Name"
                  option-value="Unit_ID"
        />
        <q-input v-model="newProduct.Goods_Name"
                 filled
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties'].includes(v))"
                 counter
                 hide-bottom-space
                 bottom-slots
                 label="عنوان درون سازمانی کالا"
                 :rules="[ val => val && val.length > 5 || 'عنوان درون سازمانی کالا الزامی است']"
        />
        <q-input v-model="newProduct.Goods_NameA"
                 filled
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties'].includes(v))"
                 counter
                 hide-bottom-space
                 bottom-slots
                 label="عنوان برون سازمانی کالا"
                 :rules="[ val => val && val.length > 5 || 'عنوان برون سازمانی کالا الزامی است']"
        />
      </q-card-section>
      <q-card-section horizontal class="q-gutter-sm q-ml-sm q-mr-sm">
        <q-input v-model="newProduct.Goods_Box"
                 filled
                 dir="ltr"
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties', 'can_only_change_goods_dimension'].includes(v))"
                 label="تعداد در کارتن"
                 type="number"
        />
        <q-input v-model="newProduct.Goods_Pak"
                 filled
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties', 'can_only_change_goods_dimension'].includes(v))"
                 dir="ltr"
                 label="تعداد در بسته"
                 type="number"
        />

        <q-input v-model="newProduct.Goods_Min"
                 filled
                 dir="ltr"
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties'].includes(v))"
                 label="نقطه جوش"
                 step="0.1"
                 type="number"
        />
      </q-card-section>
      <q-card-section horizontal class="q-gutter-sm q-mt-xs q-ml-sm text-center">
        <q-input v-model="newProduct.Goods_weight"
                 filled
                 dir="ltr"
                 label="وزن"
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties', 'can_only_change_goods_dimension'].includes(v))"
                 type="number"
        />
        <q-input v-model="newProduct.Goods_Volume"
                 filled
                 dir="ltr"
                 label="حجم"
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties', 'can_only_change_goods_dimension'].includes(v))"
                 type="number"
        />
      </q-card-section>
      <q-card-section>
        <q-input v-model="newProduct.Descriptions"
                 type="textarea"
                 :disable="!$store.state.roles.some(v=>['admin','can_change_goods_properties'].includes(v))"
                 filled
                 clearable
                 label="شرح مختصر"/>
      </q-card-section>
      <q-card-actions align="center">
        <q-btn label="تایید" type="submit"
               class="bg-indigo-6 text-white" icon="check"/>
        <q-btn label="انصراف" flat class="q-ml-sm" icon="cancel" color="red" @click="$emit('close-dialog')"/>

      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "ProductCU",
  props: {
    productInfo: {
      type: Object,
      required: false
    },
    action: {
      type: String,
    }
  },
  data() {
    return {
      repeatInsert: false,
      newProduct: {
        Goods_ID: -1,
        Goods_Name: '',
        Goods_Unit: undefined,
        Goods_Box: 0,
        Goods_Pak: 0,
        Goods_Group: undefined,
        Goods_SaleTax_D: 0,
        Goods_weight: 0,
        Goods_Min: 0,
        Goods_Volume: 0,
        Descriptions: undefined,
        Goods_NameA: undefined
      },
      goodUnits: [],
      goodsGroup: [],
      goodsGroupOptions: []
    }
  },
  methods: {
    ...mapActions({
      getGoodUnits: 'Products/getGoodsUnits',
      getGoodsGroup: 'Products/getSimpleGoodsGroupList',
      addGoods: 'Products/addProduct'
    }),
    onSubmit() {
      this.newProduct.title = this.newProduct.Goods_Name
      this.addGoods(this.newProduct).then((res) => {
        if (this.newProduct.Goods_ID === -1) {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            position: 'top',
            message: ` کالا با کد ${res[0].Goods_Code} ایجاد گردید. `
          })
          if (!this.repeatInsert) {
            this.$emit('product-inserted', this.newProduct)
          } else {
            this.newProduct.Goods_ID = -1
            this.newProduct.Goods_Box = 0
            this.newProduct.Goods_Pak = 0
            this.newProduct.Goods_SaleTax_D = 0
            this.newProduct.Goods_weight = 0
            this.newProduct.Goods_Min = 0
            this.newProduct.Goods_Volume = 0
            this.newProduct.Descriptions = undefined
          }
        } else {
          this.$q.notify({
            type: 'positive',
            color: 'positive',
            position: 'top',
            message: ` کالا با کد ${res[0].Goods_Code} ویرایش گردید. `
          })
          this.$emit('product-updated', this.newProduct)
        }
      })
    },
    filterFnGoodsGroup(val, update) {
      if (val === '') {
        update(() => {
          this.goodsGroupOptions = this.goodsGroup
        })
        return
      }

      update(() => {
        this.goodsGroupOptions = this.goodsGroup.filter(v => v.Group_Name.indexOf(val) > -1)
      })
    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
  },
  created() {
    this.getGoodsGroup({}).then((res) => {
      this.goodsGroup = res
      this.getGoodUnits().then((res) => {
        this.goodUnits = res;
        this.goodsGroupOptions = res
        if (this.productInfo !== undefined) {
          this.newProduct = Object.assign({}, this.productInfo)
          this.newProduct.Goods_Unit = this.goodUnits.filter(item => item.Unit_ID === this.newProduct.uniteID)[0] ?? undefined
          this.newProduct.Goods_Group = this.goodsGroup.filter(item => item.Group_ID === this.newProduct.Group_ID)[0] ?? undefined
        }
      })
    })

  }
}
</script>

<style scoped>

</style>